import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { setIsLoading } from "redux/loader/action";
import axios from "axios";
import Alert from "shared/components/alert";

import OnboardingModal from 'shared/components/OnboardingModal'
import banner from "assets/images/signin/banner.png";
import logo from "assets/images/heyLimeLogo.png";
import closeIcon from "assets/images/signin/cross-icon.png";

const InviteTeammates = () => {
    const [inviteLinkUrl, setInviteLinkUrl] = useState("");

    const dispatch = useDispatch();
    const {
      gameReducer: { currentUser },
      signinReducer: { invite_teammate_array }
    } = useSelector((state) => state);
    const toggleModal = () => setInviteLinkUrl("");

    const getMagicLink = async () => {
        setIsLoading(true);
        /* http://192.168.1.190:3000/apptest/getTeamLink/?team_code=ZJQP&user_name=temp5 */
        let url = process.env.REACT_APP_GET_MAGIC_LINK;
        console.log("jghruh",url,currentUser,"currentUser.team_code====",currentUser.userName);

        url = `${url}?team_code=${currentUser.team_code}&user_name=${currentUser.userName}`;

        try {
          const response = await axios.get(url);
          toggleModal();
          setInviteLinkUrl(response.data.url);
        } catch (error) {
          console.error(error, "error");
        } finally {
            setIsLoading(false);
        }
      };
      const handleCopyLink = () =>
      navigator.clipboard
        .writeText(inviteLinkUrl)
        .then(() => {
          Alert(200, "Link copied successfully");
        })
        .catch((error) => {
          console.error("Error copying to clipboard:", error);
        });

        const handleShareLink = () =>
        (window.open().location.href = `mailto:?subject= You're invited to a heyLIME team! &body=You’ve been invited to a heyLIME team!%0DTeam: ${currentUser.team.description}%0DClick on the link below to join your team (link expires in 72 hours):%0D${inviteLinkUrl}`);
      console.log(inviteLinkUrl,"inviteLinkUrl");
  return (
    <section className='invite-teammates'>
      <div className='banner'>
        <img src={banner} className='img-fluid' alt="banner" />
      </div>
      <div className='invite-teammates-content'>
        <div className='first'>
          <img src={logo} className='img-fluid logo' alt="logo" />
          <h2>Invite Teammates</h2>
          <p>Invite teammates to join you on heylime via email or by sharing an invite link. <span onClick={getMagicLink} >Get Link</span></p>
        </div>
        <div className='second'>
          <div className='input-wrapper'>
            <div className='input-box'>
              <input type="text" className='email' placeholder="Teammate Email" />
            </div>
            <div className='button-box'>
              <button>Add</button>
            </div>
          </div>
          <div className='teammate-list-wrapper'>
            <div className='teammate-list'>
              <p>Teammate@email.com</p>
              <img src={closeIcon} className='img-fluid' alt="closeIcon" />
            </div>
            <div className='teammate-list'>
              <p>Teammate@email.com</p>
              <img src={closeIcon} className='img-fluid' alt="closeIcon" />
            </div>
            <div className='teammate-list'>
              <p>Teammate@email.com</p>
              <img src={closeIcon} className='img-fluid' alt="closeIcon" />
            </div>
          </div>
          
          <button className='finish-btn'>Finish</button>
        </div>
        <OnboardingModal   toggle={toggleModal} inputValue={inviteLinkUrl}  btnText1="Copy Link"
        btnText2="Share Link"
        btnClick1={handleCopyLink}
        btnClick2={handleShareLink}/>
        <div className='third'>
          <p>© 2024 heyLIME. All rights reserved.</p>
        </div>
      </div>
      
    </section>
  )
}

export default InviteTeammates